var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNoData(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 122,
    viewBox: "0 0 119 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M105.037 44.7361C107.149 44.7361 108.861 43.026 108.861 40.906C108.861 38.796 107.149 37.0859 105.037 37.0859C102.924 37.0859 101.212 38.796 101.212 40.906C101.212 43.026 102.924 44.7361 105.037 44.7361Z",
    fill: "#2A2E37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.44275 65.4363C4.83275 65.4363 5.95874 64.3163 5.95874 62.9163C5.95874 61.5263 4.83275 60.4062 3.44275 60.4062C2.05375 60.4062 0.926758 61.5263 0.926758 62.9163C0.926758 64.3163 2.05375 65.4363 3.44275 65.4363Z",
    fill: "#2A2E37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.0102 110.716C16.3992 110.716 17.5262 109.586 17.5262 108.196C17.5262 106.806 16.3992 105.676 15.0102 105.676C13.6202 105.676 12.4932 106.806 12.4932 108.196C12.4932 109.586 13.6202 110.716 15.0102 110.716Z",
    fill: "#2A2E37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M28.459 110.716L63.768 99.6562V54.2861L28.459 65.2664V110.716Z",
    fill: "#B7BFCD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.4,
    d: "M99.0766 110.716L63.7676 99.6562V54.2861L99.0766 65.2664V110.716Z",
    fill: "#6D7C9A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M28.459 110.716L63.768 99.6562V54.2861L28.459 65.2664V110.716Z",
    fill: "#414758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M99.0766 110.716L63.7676 99.6562V54.2861L99.0766 65.2664V110.716Z",
    fill: "#414758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M99.0766 110.716L63.7676 99.6562V54.2861L99.0766 65.2664V110.716Z",
    fill: "#383D4B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M63.768 121.866L28.459 110.796V65.4365L63.768 76.5066V121.866Z",
    fill: "#5C6378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M63.7676 121.866L99.0766 110.796V65.4365L63.7676 76.5066V121.866Z",
    fill: "#4D5464"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    opacity: 0.29,
    d: "M55.768 113.866L28.459 110.796V65.4365L63.768 76.5066L55.768 113.866Z",
    fill: "url(#paint0_linear_327_13310)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    opacity: 0.29,
    d: "M71.7676 105.866L99.0766 110.796V65.4365L63.7676 76.5066L71.7676 105.866Z",
    fill: "url(#paint1_linear_327_13310)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M63.7676 54.2861L47.1666 41.8662L11.2676 53.9463L28.4586 65.2664L63.7676 54.2861Z",
    fill: "#5C6479"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M63.7676 54.2861L80.3686 41.8662L116.268 53.9463L99.0766 65.2664L63.7676 54.2861Z",
    fill: "#5C6479"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M28.4586 65.4365L63.7676 76.5066L46.1556 87.7366L11.2676 76.1665L28.4586 65.4365Z",
    fill: "#5C6479"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M99.0766 65.4365L63.7676 76.5066L81.3806 87.7366L116.268 76.1665L99.0766 65.4365Z",
    fill: "#5C6479"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M73.6195 10.7461C78.5655 24.1661 80.0406 27.146 80.5246 40.376C80.3386 43.396 80.2225 46.6759 78.7995 49.3259C76.8985 53.3659 72.2475 56.1661 67.8545 56.2161C63.3285 56.2961 58.8916 53.5261 56.8946 49.2461C55.4896 46.6561 55.5345 43.1061 57.4615 40.7561C59.5565 38.4961 63.2436 37.9359 65.8946 39.3459C68.8116 40.6859 70.5525 43.476 71.1975 46.406C71.8425 49.346 71.5595 52.536 70.7715 55.436C69.1255 62.476 67.7625 62.8261 63.7245 74.7561",
    stroke: "#667089",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M79.6401 3.63623C79.6291 5.60623 77.7921 6.81628 75.4621 6.18628C73.0091 5.76628 71.2741 5.33617 71.1621 3.57617C71.2181 1.76617 73.1891 1.06636 75.4971 0.266358C78.2631 -0.833642 79.4841 1.70623 79.6401 3.63623Z",
    fill: "#AFB7C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M63.7911 9.67601C65.0341 10.956 67.6551 11.3259 68.9321 9.36595C70.3321 7.20595 71.5311 5.62602 70.2431 4.18602C69.0001 2.90602 67.7901 3.76595 65.0241 4.86595C62.8061 5.99595 62.3351 8.26601 63.7911 9.67601Z",
    fill: "#AFB7C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M69.5271 1.50601C70.6581 1.02601 72.0131 1.3758 72.6181 2.2958C72.8751 2.5858 73.1782 3.03588 73.2672 3.37588C74.2302 5.62588 73.9271 7.85588 72.6281 8.37588C71.2061 9.11588 69.2461 7.85598 68.4961 5.72598C68.3161 5.05598 68.2272 4.72597 68.0932 4.21597C67.9472 3.00597 68.3951 1.98601 69.5271 1.50601Z",
    fill: "#474E61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M17.5256 37.7361H15.3356V35.5459H13.4576V37.7361H11.2676V39.676H13.4576V41.866H15.3356V39.676H17.5256V37.7361Z",
    fill: "#5C6479"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M22.3371 92.686H20.1471V90.4961H18.2691V92.686H16.0791V94.626H18.2691V96.8159H20.1471V94.626H22.3371V92.686Z",
    fill: "#5C6479"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M118.074 92.8062L115.395 91.4563L116.748 88.7764L114.451 87.6162L113.098 90.2961L110.418 88.9363L109.22 91.3162L111.9 92.6663L110.547 95.3462L112.844 96.5063L114.196 93.8262L116.876 95.1763L118.074 92.8062Z",
    fill: "#5C6479"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_327_13310",
    x1: 36.375,
    y1: 96.4865,
    x2: 44.858,
    y2: 72.5265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#292D36",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A2E37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_327_13310",
    x1: 71.6836,
    y1: 94.5164,
    x2: 79.2305,
    y2: 71.7665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#292D36",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A2E37"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoData);
export default __webpack_public_path__ + "static/media/icon-noData.c592337cefc8ecf6d2d488fda628db43.svg";
export { ForwardRef as ReactComponent };